var _excluded = ["borderWidth", "borderColor"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box } from '../Box';
import { applyVariations, getPaletteColor, deprecatedColorValue } from '../utils';

var boxBorder = function boxBorder(_ref) {
  var borderWidth = _ref.borderWidth,
      borderColor = _ref.borderColor,
      props = _objectWithoutProperties(_ref, _excluded);

  return {
    border: borderWidth === 0 ? '0' : "".concat(borderWidth, "px solid ").concat(getPaletteColor(borderColor, 'base')(props))
  };
};

var Card = styled(Box).withConfig({
  displayName: "Card",
  componentId: "sc-j7tjpg-0"
})(["", " ", ""], applyVariations('Card'), boxBorder);
Card.propTypes = {
  borderColor: deprecatedColorValue(),
  color: deprecatedColorValue(),
  borderWidth: PropTypes.oneOf([0, 1, 2])
};
Card.defaultProps = {
  borderColor: 'border',
  borderRadius: 'xsm',
  borderWidth: 1
};
Card.displayName = 'Card';
export default Card;